import { render, staticRenderFns } from "./FullImageDialog.vue?vue&type=template&id=98b74a3e&scoped=true"
import script from "./FullImageDialog.vue?vue&type=script&lang=js"
export * from "./FullImageDialog.vue?vue&type=script&lang=js"
import style0 from "./FullImageDialog.vue?vue&type=style&index=0&id=98b74a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b74a3e",
  null
  
)

export default component.exports